<template>
  <div>
    <div class="speed-chart">
      <svg
        style="width: 0; height: 0; position: absolute"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id="fillColor" x1="1" x2="1" y1="0" y2="1">
            <stop offset="0%" stop-color="#f13a3a" />
            <stop offset="100%" stop-color="rgba(241, 58, 58, 0)" />
          </linearGradient>
        </defs>
      </svg>
      <client-only>
        <TrendChart
          :min="0"
          :max="maxReading"
          :datasets="[
            {
              data: speedReadings,
              smooth: true,
              fill: true,
            },
          ]"
        />
      </client-only>
      <a class="button" @click.prevent="clearLocations">{{ $t("reset") }}</a>
    </div>
  </div>
</template>
<script>
import TrendChart from '@/components/vue-trend-chart/src/components/trend-chart';

export default {
  components: {
    TrendChart,
  },
  props: ['locations'],
  emits: ['clearLocations'],
  computed: {
    speedReadings() {
      if (this.locations.length < 2) {
        return [0, 0];
      }
      return this.locations.map((location) => location.coords.speed || 0);
    },
    maxReading() {
      const max = Math.max(...this.speedReadings);
      // max sure the y axis is at least 0-10
      return max > 10 ? max : 10;
    },
  },
  methods: {
    clearLocations() {
      this.$emit('clearLocations');
    },
  },
};
</script>
<style lang="scss">
.speed-chart .vtc {
  .stroke {
    stroke: var(--brand);
    stroke-width: 2;
  }
  .fill {
    fill: url(#fillColor);
    fill-opacity: 0.5;
  }
}
.slide-enter-active {
  transition: all 0.5s ease-in-out;
}
.slide-leave-active {
  transition: all 0.5s ease-out;
}
.slide-enter,
.slide-leave-to {
  transform: scaleY(0);
  opacity: 0;
  margin-top: -10em;
}
</style>
